import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import CommonLoader from '../../components/common/commonLoader'
// import { useAuthStore } from '../../configs/permissionGate'
import { useAuthStore } from '../../store/authStore'

type Props = {
  children: React.ReactNode
}

const GuestRoute = ({ children }: Props) => {
  const { authenticated, userData } = useAuthStore()

  return !authenticated ? (
    <Suspense fallback={<CommonLoader />}>
      <>{children}</> <Outlet />
    </Suspense>
  ) : (
    <Navigate to={userData?.is_admin ? `/backoffice/user` : '/home'} replace />
  )
}

export default GuestRoute
